import { type FC } from 'react';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { type EditorState, type LexicalEditor } from 'lexical';
import { $generateHtmlFromNodes } from '@lexical/html';
import { type CustomOnChangePluginPropType } from '../types/propsType';
import { NextgenDOMPurify } from '../../utils/NextgenDOMPurify/NextgenDOMPurify';

const CustomOnChangePlugin: FC<CustomOnChangePluginPropType> = ({ getHTMLUpdate }: CustomOnChangePluginPropType) => {
  const handleOnChange = (_editorState: EditorState, editor: LexicalEditor) => {
    editor.update(() => {
      const htmlString = $generateHtmlFromNodes(editor, null);
      const sanitizedHTML = NextgenDOMPurify(htmlString);
      getHTMLUpdate?.(sanitizedHTML);
    });
  };
  return <OnChangePlugin onChange={handleOnChange} />;
};

export default CustomOnChangePlugin;
